export const mergeLabelValues = (labelsMap, key, values) => {
  var _labelsMap$get;
  const newValues = Array.isArray(values) ? values : [values];
  const existingValues = (_labelsMap$get = labelsMap.get(key)) !== null && _labelsMap$get !== void 0 ? _labelsMap$get : new Set();
  const updatedValues = new Set([...existingValues, ...newValues]);
  const updatedLabelsMap = new Map(labelsMap);
  updatedLabelsMap.set(key, updatedValues);
  return updatedLabelsMap;
};